import { useEffect, useRef, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from 'react-i18next';
import copyIcon from "../../../Images/copy.png";

const CopyBtn = ({ text }) => {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleCopy = () => {
        setCopied(true);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setCopied(false);
        }, 1200);
    };

    return (
        <CopyToClipboard text={text ?? ""} onCopy={handleCopy}>
            <button
                type="button"
                className="btn btn-secondary"
                style={{
                    padding: "0.25rem",
                    lineHeight: 0,
                    flex: "0 0 auto",
                    position: "relative",
                }}
                onClick={(e) => e.stopPropagation()}
                aria-label={t('common.select')}
                title={t('common.select')}
            >
                <span
                    style={{
                        position: "relative",
                        display: "block",
                        width: 16,
                        height: 16,
                    }}
                >
                    {/* Copy icon */}
                    <img
                        src={copyIcon}
                        alt=""
                        style={{
                            width: 16,
                            height: 16,
                            display: "block",
                            opacity: copied ? 0 : 1,
                            transition: "opacity 150ms ease",
                        }}
                    />

                    {/* Checkmark */}
                    <span
                        aria-hidden="true"
                        style={{
                            position: "absolute",
                            inset: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#198754",
                            fontSize: 16,
                            fontWeight: "bold",
                            opacity: copied ? 1 : 0,
                            transform: copied ? "scale(1)" : "scale(0.7)",
                            transition:
                                "opacity 150ms ease, transform 150ms ease",
                        }}
                    >
                        ✓
                    </span>
                </span>
            </button>
        </CopyToClipboard>
    );
};

export default CopyBtn;